export interface GetAmbarListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAmbarListPagingAndFilterResponseData
}

export interface GetAmbarListPagingAndFilterResponseData {
    items: GetAmbarListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetAmbarListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetAmbarListPagingAndFilterResponseTotals {
    totalQuantity: number
    totalWeight: number
    totalDesi: number
    totalDetailVolumetricWeight: number
    saleInvoiceTotalAmount: number
    purchaseInvoiceTotalAmount: number
    /** Döviz bazında, satır hücresiyle aynı biçimde: "1.250,00 TRY, 45,00 USD" */
    expectedIncomeTotals: string
    expectedOutcomeTotals: string
    rowCount: number
}

export interface GetAmbarListPagingAndFilterResponseItem {
    ambarId: string
    companyId: string
    refNo: string
    customerId: string
    carryTypeId: string
    carryMethodId: string
    waitTime: number
    warehouseReceipt: string
    customerDeliveryNoteNumber: string
    isBridge: boolean
    isAdditionalLocation: boolean
    expressVehicleId: string
    divisionId: string
    poId: string
    poNo: string
    note: string
    ambarVoyageId: any
    ambarVoyageRefNo?: string | null
    customerName: string
    carryTypeName: string
    /** E-irsaliyenin Uyumsoft'taki gerçek durumu. */
    irsaliyeStatusName?: string
    /** Listede gösterilen e-irsaliye durumu: Gönderildi / GİB'e gönderilmedi / boş. */
    gibStatus?: string
    /** Durum "Hata" ise işlem geçmişindeki son hata metni. */
    irsaliyeStatusMessage?: string
    /** Durumun en son ne zaman okunduğu. */
    irsaliyeStatusDateStr?: string
    carryMethodName: string
    expressVehicleName: string
    divisionName: string
    poName: string
    ambarVoyage: GetAmbarListPagingAndFilterResponseAmbarVoyage
    orderDate: any
    loadDate: any
    deliveryDate: any
    senderCustomerId: any
    senderCustomerAddressTypeId: any
    senderCustomerAddressText: any
    senderCustomerName: any
    senderCustomerAddressTypeName: any
    receiverCustomerId: any
    receiverCustomerAddressTypeId: any
    receiverCustomerAddressText: any
    receiverCustomerName: any
    receiverCustomerAddressTypeName: any
    loadingFirmCustomerId: any
    loadingFirmCustomerAddressTypeId: any
    loadingFirmCustomerAddressText: any
    loadingFirmCustomerName: any
    loadingFirmCustomerAddressTypeName: any
    deliverFirmCustomerId: any
    deliverFirmCustomerAddressTypeId: any
    deliverFirmCustomerAddressText: any
    deliverFirmCustomerName: any
    deliverFirmCustomerAddressTypeName: any
    loadingCountyId: any
    loadingDistrictId: any
    loadingNeighborhoodId: any
    deliverCountyId: any
    deliverDistrictId: any
    deliverNeighborhoodId: any
    loadingCountyName: any
    loadingDistrictName: any
    loadingNeighborhoodName: any
    deliverCountyName: any
    deliverDistrictName: any
    deliverNeighborhoodName: any
    loadingRegionId: any
    loadingRegionName: any
    deliverRegionId: any
    deliverRegionName: any
    shippingStatusId: any
    shippingCreateDate: any
    shippingCreateDateStr: any
    shippingLoadDate: any
    shippingLoadDateStr: any
    shippingDeliverDate: any
    shippingDeliverDateStr: any
    shippingDeliverer: any
    shippingReceiver: any
    shippingStatusName: any
    ambarProducts: any[]
    ambarExpectedIncomeOutcomes: any[]
    fileArchives: any[]
    ambarVoyageStatus?: string
    /** Teslim tarihi ve teslim alan alanlarından hesaplanır: Teslim Edildi / Eksik Bilgi / İşlenmedi / İptal. */
    deliveryStatus?: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAmbarListPagingAndFilterResponseAmbarVoyage {
    ambarVoyageId: string
    companyId: string
    refNo: string
    vehicleId: string
    trailerId: any
    driverId: string
    supplierId: string
    vehicleName: any
    trailerName: any
    driverName: any
    supplierName: any
    isCustomActive: boolean
}

export const initialGetAmbarListPagingAndFilterResponseData: GetAmbarListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}